// extracted by mini-css-extract-plugin
export default {"wrapper":"SmallLink_wrapper__hHtZZ","pulse":"SmallLink_pulse__X2PCW"};